import ReduxHelper from 'lib/ReduxHelper';
import { DASHBOARD_ACTION_TYPES as AT } from './Dashboard.actions';
import { APP_ACTION_TYPES } from '../app/App.actions';

export const defaultState = {
  error: null,
  fetching: false,
  data: null,

  readGDPRError: null,
  readingGDPR: false,
  readGDPR: null,
};

const dashboardReducer = (state = defaultState, action) => {
  switch (action.type) {
    case AT.DASHBOARD_FETCH_DATA:
      return Object.assign({}, state, { fetching: true });
    case AT.DASHBOARD_FETCH_DATA_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        data: action.payload,
        error: null,
      });
    case AT.DASHBOARD_FETCH_DATA_FAIL:
      return Object.assign({}, state, {
        data: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.DASHBOARD_CLEAR_DATA:
      return Object.assign({}, state, {
        fetching: false,
        data: null,
        error: null,
      });
    case AT.DASHBOARD_READGDPR:
      return Object.assign({}, state, { readingGDPR: true });
    case AT.DASHBOARD_READGDPR_SUCCESS:
      return Object.assign({}, state, {
        readingGDPR: false,
        readGDPR: action.payload,
        readGDPRError: null,
      });
    case AT.DASHBOARD_READGDPR_FAIL:
      return Object.assign({}, state, {
        readGDPR: null,
        readGDPRError: ReduxHelper.extractError(action),
      });
    case AT.DASHBOARD_CLEAR_READGDPR:
      return Object.assign({}, state, {
        readingGDPR: false,
        readGDPR: null,
        readGDPRError: null,
      });
    case APP_ACTION_TYPES.LOGOUT:
      return defaultState;
    default:
      return state;
  }
};

export default dashboardReducer;
